// extracted by mini-css-extract-plugin
export var container = "_9c-0";
export var icon = "_9c-1";
export var text = "_9c-2";